export default __webpack_public_path__ + "static/media/WonColorIcon.21171c74.svg";